<template>
  <v-app>
    <v-progress-linear
      :indeterminate="true"
      class="ma-0"
      style="z-index:100"
      height="2"
      :active="loaderActive"
      absolute
      color="teal accent-2"
    />
    <v-app-bar
      v-if=" toolbarVisible"
      fixed
      app
      dark
      color="#262f3d"
      class="no-print"
    >
      <!-- :hide-on-scroll="(_appBarTabs || []).length > 0" -->
      <v-app-bar-nav-icon @click.stop="toggleNav" />

      <v-toolbar-title>
        <v-layout
          align-center
          ma-0
        >
          <v-icon
            v-if="appTitleIcon"
            left
          >
            {{ appTitleIcon }}
          </v-icon>{{ appTitle }}
        </v-layout>
      </v-toolbar-title>

      <v-spacer />
      <v-chip
        v-if="_messagingEnabled.email !== undefined"
        class="mx-4"
        :color="`${_messagingEnabled.email ? 'teal accent-2' : 'error'}`"
        light
      >
        <v-icon>email</v-icon> 
        <span class="hidden-xs-only ml-2">
          {{ `${_messagingEnabled.email ? 'Email active' : 'Email inactive'}` }}
        </span>
      </v-chip>

      <v-menu offset-y>
        <template #activator="{ on }">
          <SiUserAvatar
            size="36"
            class="cursor-pointer"
            v-on="on"
          />
        </template>
        <v-list>
          <v-list-item :to="`/user/`">
            <v-list-item-icon> <v-icon>account_circle</v-icon> </v-list-item-icon>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item to="/logout">
            <v-list-item-icon> <v-icon>exit_to_app</v-icon> </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <template
        v-if="(_appBarTabs || []).length > 0"
        #extension
      >
        <v-tabs
          background-color="transparent"
          centered
          colorxxx="teal accent-2"
        >
          <template v-for="(tab, i) in _appBarTabs">
            <v-tab
              v-if="tab.type !== 'action'"
              :id="tab.to"
              :key="tab.to"
              class="px-10"
              :to="tab.to"
            >
              {{ tab.text }}
            </v-tab>
            <v-btn
              v-if="tab.type === 'action'"
              :key="i"
              text
              :disabled="_loader"
              class="font-italic"
              color="white"
              style="margin-top: 6px; opacityxxx:0.5"
              @click="tab.cb"
            >
              <v-icon
                v-if="tab.icon"
                left
              >
                {{ tab.icon }}
              </v-icon>
              {{ tab.text }}
            </v-btn>
          </template>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb, auth } from '@/plugins/firebase'
import clientPath from '@/plugins/client-path'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'

export default {
  mixins: [ helpers, binder ],
  data () {
    return {
      toolbarVisible: true,
      loaderActive: false,
      scrollPos: 0,
      scrollThreshold: 0,
      process: process
    }
  },
  computed: {
    ...mapGetters(['_user', '_drawer', '_loader', '_appBarTabs', '_appBarTitle', '_messagingEnabled']),
    appTitle () {
      if (typeof this._appBarTitle === 'object') return this._appBarTitle.title
      return this._appBarTitle
    },
    appTitleIcon () {
      if (typeof this._appBarTitle === 'object') return this._appBarTitle.icon
      return null
    },
    logoClass () {
      return this.$route.name === 'home'
        ? this.scrollPos > this.scrollThreshold
          ? undefined
          : 'white--text'
        : undefined
    },
    appBarColor () {
      return this.$route.name === 'home'
        ? this.scrollPos > this.scrollThreshold
          ? 'white'
          : 'transparent'
        : 'white'
    }
  },
  watch: {
    '$route.params.page' () {
      this.toolbarVisible = false
      this.$nextTick(() => { this.toolbarVisible = true })
    },
    _loader (v) {
      if (v) {
        this.loaderActive = true
      } else {
        setTimeout(() => { this.loaderActive = false }, 500)
      }
    }
  },
  beforeMount () {
    var authWatch = auth.onAuthStateChanged(user => {
      if (user) {
        clientPath.init()
        this.bindCalculators()
        this.bindProducts()
        this.$bindRtdbStore('set_messagingEnabled', `messaging/_enabled`)
        // this.$bindStorexxx(rtdb.ref(`messaging/_enabled`), 'set_messagingEnabled')
        authWatch()
      }
    })
  },
  mounted () {
    let ref = document.referrer || ''
    let safeRef = btoa(ref)
    if (ref && (this._hostFromUrl(ref) !== this._hostFromUrl(window.location.href))) rtdb.ref(`stats/referrers/${safeRef}`).transaction(cnt => { return (cnt || 0) + 1 })
  },
  methods: {
    onScroll (e) {
      this.scrollPos = e.target.scrollingElement.scrollTop
    },
    bindCalculators () {
      this.$store.commit('set_loader', true)
      rtdb.ref('calculators/_list').on('value', s => {
        this.$store.commit('set_loader', false)
        this.$store.commit('set_calculators', s.val())
      })
    },
    bindProducts () {
      rtdb.ref('products').once('value', s => {
        this.$store.commit('set_products', s.val())
      })
    },
    toggleNav () {
      this.$store.commit('set_drawer', !this._drawer)
    }
  }
}
</script>


<style lang="scss">

</style>
